import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField, Tooltip, ClickAwayListener } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import ComboText from '../../ComboText/';
import { LANGUAGES } from '../../../utils/ConstantsMain';
import moment from 'moment';
// import MultipleSelect from '../../../components/MultipleSelect';
// import TextCounter from '../../../components/TextCounter';
// import Select from '../../../components/SimpleSelect/SelectMain'

//import * as moment from 'moment';

const styles = () => ({
  gridTextField: {
    flexWrap: 'nowrap',
  },
  TextField: {
    maxWidth: '536px',
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296
    },
  },
  TextFieldNumber: {
    maxWidth: '536px',
    margin: '0 0 7px 0',
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296
    },
  },
  comboText: {
    marginBottom: 10,
    '@media screen and (max-width: 400px)': {
      width: '96%',
      minWidth: 296,
    },
    '&:last-child': {
      marginBottom: 0,
    }
  },
  gridContainer: {
    marginTop: 35,
  },
  MultipleSelect: {
    maxWidth: '536px',
    width: '100%',
  },
  containerParagraph: {
    fontSize: 16,
    fontWeight: 'bold',
    width: 'min-content',
    padding: 16,
    backgroundColor: 'rgba(53, 185, 182, 0.1)',
    borderRadius: 4,
    margin: '0 0 16px',
  },
  textParagraph: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    margin: 0,
  },
  input_icon: {
    maxWidth: '544px',
    width: '100%',
    paddingRight: 8,
    minWidth: '75%',
    margin: '0 0 -15px 0',
  },
  input_iconNumber: {
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '75%',
    width: '100%',
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '4px 0 0',
    padding: 8,
    maxWidth: 232,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold',
    },
  },
  '@media screen and (min-width: 983px) and (max-width: 1179.98px)': {
    input_icon: {
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconNumber: {
      maxWidth: '92%',
      minWidth: '92%',
    }
  },
  '@media screen and (min-width: 769px) and (max-width: 982.98px)': {
    input_icon: {
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconNumber: {
      maxWidth: '92%',
      minWidth: '92%',
    }
  },
  // '@media screen and (max-width: 768.98px)': {
  //   input_icon: {
  //     width: '92%',
  //     margin: '0 1.4% -10px 0',
  //   },
  //   input_iconNumber: {
  //     minWidth: '77%',
  //     width: '92%',
  //   },
  // },
  // '@media screen and (max-width: 411.98px)': {
  //   input_icon: {
  //     margin: '0 0 -10px 0',
  //   },
  // },
});

const AboutFormFirm = props => {
  const [numChar, setNumChar] = useState(0);

  const [ringStyle, setRingStyle] = useState({
    stroke: '',
    strokeDasharray: '',
  });

  const styleRing = (numChar) => {
    const r = 15;
    const circleLength = 2 * Math.PI * r;
    const mint = '#35b9b6';

    let colored = (circleLength * numChar) / 300;
    let gray = circleLength - colored > 0 ? circleLength - colored : 0;

    setRingStyle({
      stroke:
        300 - numChar <= 0
          ? 'red'
          : 300 - numChar <= 20
            ? 'orange'
            : mint,
      strokeDasharray: `${colored} ${gray}`,
    });
  };

  const countChar = event => {
    setNumChar(event.target.value.length);
    styleRing(event.target.value.length);
  };

  const {
    // dirty,
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
    setError,
    createAt,
    role
  } = props;

  const handleTagSelect = field => value => {
    setFieldValue(field, value);
  };

  const memberSince = moment.unix(createAt.seconds).utc().format('DD/MM/YYYY');
  // const getIndex = ESPECIALIDADITEMS.findIndex(item => item.title === values.specialties[0])

  /*  const getDefaults = values.specialties.map(specialty => {
     const getIndex = ESPECIALIDADITEMS.findIndex(item => item.title === specialty)
     return ESPECIALIDADITEMS[getIndex];
   }) */

  const [openNumber, setOpenNumber] = useState(false);

  const handleTooltipCloseNumber = () => {
    setOpenNumber(false);
  };

  const handleTooltipOpenNumber = () => {
    setOpenNumber(true);
  };

  const [openCedula, setOpenCedula] = useState(false);

  const handleTooltipCloseCedula = () => {
    setOpenCedula(false);
  };

  const handleTooltipOpenCedula = () => {
    setOpenCedula(true);
  };

  const [openLanguages, setOpenLanguages] = useState(false);

  const handleTooltipCloseLanguages = () => {
    setOpenLanguages(false);
  };

  const handleTooltipOpenLanguages = () => {
    setOpenLanguages(true);
  };

  return (
    <form>
      <Grid
        container
        direction="column"
        classes={{ root: classes.gridContainer }}
      >

        <div className={classes.containerParagraph}>
          <p className={classes.textParagraph}>
            Miembro desde: {memberSince}
          </p>
        </div>
        <div className="contentInput">
          <TextField
            label='Nombre del despacho*'
            id="officeName"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.officeName}
            helperText={touched.officeName && errors.officeName ? errors.officeName : ''}
            error={touched.officeName && errors.officeName ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>

        <Grid container direction="row" classes={{ root: classes.gridTextField }}>
          <Grid item xs classes={{ root: classes.input_icon }}>
            <TextField
              label="Cédula profesional del titular"
              id="cedula"
              type="text"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.cedula ? values.cedula : ''}
              helperText={touched.cedula && errors.cedula ? errors.cedula : ''}
              error={touched.cedula && errors.cedula ? true : false}
              fullWidth
              classes={{ root: classes.TextField }}
              style={{ marginBottom: 20 }}
            />
          </Grid>
          <Grid>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipCloseCedula}>
                  <Tooltip
                    onClose={handleTooltipCloseCedula}
                    open={openCedula}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{ tooltip: classes.customTooltip }}
                    title={
                      <p className={classes.tooltipParagraph}>
                        El campo "cédula profesional del titular" <b>no es obligatorio</b>, pero recomendamos
                        llenar el campo con fines de <b>credibilidad</b> y <b>veracidad</b> de la información proporcionada.
                      </p>
                    }
                    placement='left'
                  >
                    <img
                      style={{ marginTop: 12 }}
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenCedula}
                    />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title={
                    <p className={classes.tooltipParagraph}>
                      El campo "cédula profesional del titular" <b>no es obligatorio</b>, pero recomendamos
                      llenar el campo con fines de <b>credibilidad</b> y <b>veracidad</b> de la información proporcionada.
                    </p>
                  }
                  placement='bottom'
                >
                  <img style={{ marginTop: 12 }} src="../../img/profile/ayuda.png" alt="?" />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>

        <Grid container classes={{ root: classes.gridTextField }}>
          <Grid item classes={{ root: classes.input_iconNumber }}>
            <TextField
              label="Número telefónico*"
              id="phone"
              type="text"
              variant="outlined"
              onBlur={handleBlur}
              onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
              inputProps={{ minLength: 10, maxLength: 10 }}
              onChange={handleChange}
              value={values.phone}
              helperText={touched.phone && errors.phone ? errors.phone : ''}
              error={touched.phone && errors.phone ? true : false}
              fullWidth
              classes={{ root: classes.TextFieldNumber }}
            />
          </Grid>
          <Grid item>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipCloseNumber}>
                  <Tooltip
                    onClose={handleTooltipCloseNumber}
                    open={openNumber}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{ tooltip: classes.customTooltip }}
                    title={
                      <p className={classes.tooltipParagraph}>
                        Este número de teléfono <b>no será publicado</b> en el sitio y podría
                        ocuparse para cuestiones de soporte técnico de la plataforma
                      </p>
                    }
                    placement='left'
                  >
                    <img
                      style={{ marginTop: 12 }}
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenNumber}
                    />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title={
                    <p className={classes.tooltipParagraph}>
                      Este número de teléfono <b>no será publicado</b> en el sitio y podría
                      ocuparse para cuestiones de soporte técnico de la plataforma
                    </p>
                  }
                  placement='bottom'
                >
                  <img style={{ marginTop: 12 }} src="../../img/profile/ayuda.png" alt="?" />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>
        <div className="contentInput">
          <TextField
            label="Número de años de experiencia"
            id="expYears"
            type="text"
            variant="outlined"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.expYears}
            helperText={touched.expYears && errors.expYears ? errors.expYears : ''}
            error={touched.expYears && errors.expYears ? true : false}
            fullWidth
            style={{ marginBottom: 7 }}
            classes={{ root: classes.TextField }}
          />
          <div className="contentSpace" ></div>
        </div>

        <Grid container classes={{ root: classes.gridTextField }}>
          <Grid item classes={{ root: classes.input_icon }}>
            <ComboText
              labelText={'Idioma'}
              itemsCombo={LANGUAGES}
              widthField={536}
              multiple={true}
              handleChanges={handleTagSelect('languages')}
              errors={errors.languages}
              touched={touched.languages}
              handleBlur={handleBlur}
              name={'languages'}
              valuesMul={values.languages}
              sizeField={classes.comboText}
              cierre={true}

            />
          </Grid>
          <Grid item>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipCloseLanguages}>
                  <Tooltip
                    onClose={handleTooltipCloseLanguages}
                    open={openLanguages}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{ tooltip: classes.customTooltip }}
                    title={
                      <p className={classes.tooltipParagraph}>
                        Este campo se refiere a los idiomas que dominas como despacho.
                      </p>
                    }
                    placement='left'
                  >
                    <img
                      style={{ marginTop: 12 }}
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenLanguages}
                    />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{ tooltip: classes.customTooltip }}
                  title={
                    <p className={classes.tooltipParagraph}>
                      Este campo se refiere a los idiomas que dominas como despacho.
                    </p>
                  }
                  placement='bottom'
                >
                  <img style={{ marginTop: 12 }} src="../../img/profile/ayuda.png" alt="?" />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>
      </Grid>

      <div className="horizontal-layout" style={{ marginTop: 24 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </div>
    </form>
  );
};

export default withStyles(styles)(AboutFormFirm);